/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import { Link } from 'react-router-dom'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import { config } from '../config/config'; // eslint-disable-next-line
const Details = (props) => {
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [commonLangugaeContent, setCommonLangugaeContent] = useState([]); // eslint-disable-next-line
	const [activeFaq, setActiveFaq] = useState('0');
	const [faqContent, setFaqContent] = useState([]);
	useEffect(() => {
		getLanguagePack();
		// eslint-disable-next-line
	}, []);

	function openHideFaq(type) {
		setActiveFaq(type.toString());
	}

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setCommonLangugaeContent(response.data.WCS.AAA);
					}
					if (response?.data?.WCS?.FAQ) {
						setPageLanguageContent(response.data.WCS.FAQ);
						let objArr = Object.entries(response.data.WCS.FAQ);
						objectToArray(objArr);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.FAQ) {
				setPageLanguageContent(checkData?.FAQ);
				let objArr = Object.entries(checkData?.FAQ);
				objectToArray(objArr);
			}
			if (checkData?.AAA) {
				setCommonLangugaeContent(checkData.AAA);
			}
		}
	}

	function objectToArray(objArr) {
		let faqArr = [];
		if (objArr && objArr.length > 0) {
			for (let i = 0; i < objArr.length; i += 2) {
				let d = {};
				d['question'] = objArr[i]['1'];
				d['answer'] = objArr[i + 1]['1'];
				faqArr.push(d);
			}
		}
		setFaqContent(faqArr);
	}

	return (
		<>
			<div className='section-banner sbg-3 ptb-100'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-12'>
							<div className='banner-content'>
								<h2>{commonLangugaeContent['AAA008'] ? commonLangugaeContent['AAA008'] : ''}</h2>
								<nav aria-label='breadcrumb'>
									<ol className='breadcrumb'>
										<li className='breadcrumb-item'>
											<Link to='/'>{commonLangugaeContent['AAA001'] ? commonLangugaeContent['AAA001'] : ''} </Link>
										</li>
										<li className='breadcrumb-item active' aria-current='page'>
											{commonLangugaeContent['AAA004'] ? commonLangugaeContent['AAA004'] : ''}
										</li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='faq-section pt-100 pb-70'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-lg-7 col-md-6'>
							<div className='faq-content' data-aos='fade-up' data-aos-delay='100'>
								{faqContent &&
									faqContent.length > 0 &&
									// eslint-disable-next-line
									faqContent.map((item, i) => (
										<div key={i}>
											<div className='faq-item' onClick={() => openHideFaq(i)}>
												<div className='faq-question'>{item?.question}</div>
												<div className='icon-container'>
													<i className='bx bx-chevron-down'></i>
												</div>
											</div>
											<div className={activeFaq && activeFaq === i.toString() ? 'faq-answer active' : 'faq-answer'}>
												<p
													dangerouslySetInnerHTML={{ __html: item?.answer.replace(/\\n/g, '<br><br>') }}
													style={{ color: '#fff', whiteSpace: 'pre-line' }}>														
												</p>
											</div>
										</div>
									))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Details;
